module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-indicators"
  }, [_c('h1', [_vm._v("List of Indicators")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll(1)
      }
    }
  }, [_vm._v("Indicator 1. HIV Testing Episodes")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll(2)
      }
    }
  }, [_vm._v("Indicator 2. HIV Testing Rate")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll(3)
      }
    }
  }, [_vm._v("Indicator 3. New HIV Diagnoses")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll(4)
      }
    }
  }, [_vm._v("Indicator 4. Stage of HIV Infection at Diagnosis")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll(5)
      }
    }
  }, [_vm._v("Indicator 5. HIV Cascade of Care")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll(6)
      }
    }
  }, [_vm._v("Indicator 6. Programmatic Compliance Score (PCS)")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('7a')
      }
    }
  }, [_vm._v("Indicator 7. New Antiretroviral Therapy Starts")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('8a')
      }
    }
  }, [_vm._v("Indicator 8. CD4 Cell Count at ART Initiation")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('9a')
      }
    }
  }, [_vm._v("Indicator 9. Active and Inactive Drug Treatment Program (DTP) Participants")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('10a')
      }
    }
  }, [_vm._v("Indicator 10. Antiretroviral Adherence")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('11a')
      }
    }
  }, [_vm._v("Indicator 11. Resistance Testing and Results")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('12a')
      }
    }
  }, [_vm._v("Indicator 12. AIDS-Defining Illness")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('13a')
      }
    }
  }, [_vm._v("Indicator 13. HIV-Related Mortality")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('appendices')
      }
    }
  }, [_vm._v("Appendices")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56710d3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/web/components/ListIndicators.vue
// module id = 132
// module chunks = 0